import { atom } from 'recoil';

export interface FinanceState {
  dealerRef: string;
  dealerFloor?: string;
  vehicleImage: string;
  price: number;
  mmCode: string;
  used: boolean;
  year?: number;
  make?: string;
  model?: string;
  variant?: string;
  mileage: string;
  region?: string;
  transmission?: string;
  'redirect-url'?: string;
  'exit-to-vehicles'?: string;
  source?: string;
}

export const financeState = atom<FinanceState>({
  key: 'finance',
  default: {
    dealerRef: '',
    dealerFloor: undefined as undefined | string,
    vehicleImage: '',
    price: 0,
    mmCode: '',
    used: false,
    year: undefined as undefined | number,
    make: undefined as undefined | string,
    model: undefined as undefined | string,
    variant: undefined as undefined | string,
    mileage: '0',
    region: undefined as undefined | string,
    transmission: undefined as undefined | string,
    'redirect-url': process.env.NEXT_PUBLIC_CLIENT_URL,
    'exit-to-vehicles': process.env.NEXT_PUBLIC_CLIENT_URL,
    source: 'KIA.CO.ZA WEBSITE',
  },
});
